import { render } from "./AioConfirm.vue?vue&type=template&id=5a4fdb94&scoped=true&ts=true"
import script from "./AioConfirm.vue?vue&type=script&lang=ts"
export * from "./AioConfirm.vue?vue&type=script&lang=ts"

import "./AioConfirm.vue?vue&type=style&index=0&id=5a4fdb94&scoped=true&lang=less"

import exportComponent from "/home/www-fe/fe-prod/workspace/talbook_bfe_h5_base_frame_refs-heads-master/source_code/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a4fdb94"]])

export default __exports__